import React from 'react'
import PropTypes from 'prop-types'

import { Grid } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './MainModuleContainer'
import Enhancer from './MainModuleEnhancer'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'

import MainModuleRugsRow from 'Components/MainModuleRugsRow'
import Permissions from 'Components/Permissions'
import PreviewModal from 'Components/PreviewModal/PreviewModalHome'
import StatisticsSegment from 'Components/StatisticsSegment'

const MainModule = props => {
  const {
    currentIndex,
    currentPicture,
    currentRug,
    nextPicture,
    previewExpanded,
    previewOpen,
    previousPicture,
    recent,
    recentMarkedForDesigners,
    recentOrders,
    setCurrentIndex,
    togglePreview,
    togglePreviewExpansion,
    user,
  } = props

  return (
    <Grid>
      <Permissions
        permissions="modules.statistics"
        render={() => (
          <Grid.Row>
            <Grid.Column width={16}>
              <StatisticsSegment statistics={props.statistics} />
            </Grid.Column>
          </Grid.Row>
        )}
      />

      <MainModuleRugsRow
        recent={recent}
        recentMarkedForDesigners={recentMarkedForDesigners}
        recentOrders={recentOrders}
        setCurrentIndex={setCurrentIndex}
        togglePreview={togglePreview}
        user={user}
      />

      {previewOpen && (
        <PreviewModal
          currentIndex={currentIndex}
          currentPicture={currentPicture}
          currentRug={currentRug}
          expanded={previewExpanded}
          next={nextPicture}
          open={previewOpen}
          previous={previousPicture}
          setCurrentIndex={setCurrentIndex}
          toggle={togglePreview}
          toggleExpansion={togglePreviewExpansion}
        />
      )}
    </Grid>
  )
}

MainModule.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  currentPicture: PropTypes.string.isRequired,
  currentRug: PropTypes.object.isRequired,
  nextPicture: PropTypes.bool.isRequired,
  previewExpanded: PropTypes.bool.isRequired,
  previewOpen: PropTypes.bool.isRequired,
  previousPicture: PropTypes.bool.isRequired,
  recent: PropTypes.array.isRequired,
  recentMarkedForDesigners: PropTypes.array.isRequired,
  recentOrders: PropTypes.array.isRequired,
  setCurrentIndex: PropTypes.func.isRequired,
  statistics: PropTypes.object.isRequired,
  togglePreview: PropTypes.func.isRequired,
  togglePreviewExpansion: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
  StandardLoader('Calculating statistics…'),
  StandardError,
)

export default composed(MainModule)
